import { render, staticRenderFns } from "./ShippingLeadTimeEvents.vue?vue&type=template&id=0c7a90aa&scoped=true&"
import script from "./ShippingLeadTimeEvents.vue?vue&type=script&lang=js&"
export * from "./ShippingLeadTimeEvents.vue?vue&type=script&lang=js&"
import style0 from "./ShippingLeadTimeEvents.vue?vue&type=style&index=0&id=0c7a90aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7a90aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCard,VCardText,VCol,VDivider,VListItemAvatar,VRow})
